import { MutationHookOptions, useMutation } from '@apollo/client';

import { MutateEventAttendeeData } from 'app/shared/typings';

import {
  UPDATE_EVENT_ATTENDEE_OCCASION,
  UPDATE_EVENT_ATTENDEE_VISIBLE_TO_USER,
} from './mutations';

interface UpdateEventAttendeeVisibleToUserParams {
  eventId?: string | number;
  token?: string;
  visibleToUser?: boolean;
}

export interface UpdateEventAttendeeVisibleToUserApiResponse {
  updateEventAttendeeVisibleToUser: MutateEventAttendeeData;
}

export const UpdateEventAttendeeVisibleToUser = (
  params: MutationHookOptions<
    UpdateEventAttendeeVisibleToUserApiResponse,
    UpdateEventAttendeeVisibleToUserParams
  > = {}
) => {
  return useMutation<UpdateEventAttendeeVisibleToUserApiResponse>(
    UPDATE_EVENT_ATTENDEE_VISIBLE_TO_USER,
    params
  );
};

interface UpdateEventAttendeeOccasionVariables {
  eventId?: number;
  occasion?: string;
  occasionDetails?: string;
}

export interface UpdateEventAttendeeOccasionData {
  updateEventAttendeeOccasion: MutateEventAttendeeData;
}

export const UpdateEventAttendeeOccasion = (
  params: MutationHookOptions<
    UpdateEventAttendeeOccasionData,
    UpdateEventAttendeeOccasionVariables
  > = {}
) => {
  return useMutation<UpdateEventAttendeeOccasionData>(
    UPDATE_EVENT_ATTENDEE_OCCASION,
    params
  )[0];
};
